import React from 'react';
import { Box, IconButton, TextField } from '@mui/material';
import { Plus, Mic, Square  } from 'lucide-react';

export function InputBar({
  value,
  onChange,
  onSubmit,
  loading,
  onKeyDown,
}: {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  loading: boolean;
}) {
  return (
    <Box sx={{ px: 1.5, pt: 0, pb: '15px', display: 'flex', flexDirection: 'column', gap: 0, borderTop: '1px solid', borderColor: 'divider' }}>
      <TextField
        fullWidth
        placeholder="Ask TAI anything..."
        value={value}
        onChange={onChange}
        onKeyDown={onKeyDown}
        size="small"
        multiline
        minRows={1}
        maxRows={3}
        variant="standard"
        InputProps={{ disableUnderline: true }}
        sx={{
          m: 0,
          '& .MuiInputBase-root': { bgcolor: 'transparent', border: 'none', outline: 'none', alignItems: 'flex-start' },
          '& .MuiInputBase-inputMultiline': {
            px: 0,
            pt: '10px',
            pb: 0,
            fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
            fontSize: 18,
            fontWeight: 500,
            lineHeight: '32px',
            maxHeight: 72,
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
            wordBreak: 'break-word',
          },
          '& .MuiInputBase-inputMultiline::placeholder': {
            fontFamily: 'Inter, system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif',
            fontSize: 18,
            fontWeight: 500,
            opacity: 0.6,
          },
          '& .Mui-focused .MuiInputBase-root': { outline: 'none' },
        }}
      />

      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <IconButton size="small" aria-label="add" disabled sx={{ width: 32, height: 32, borderRadius: 8, mr: 'auto' }}>
          <Plus size={22} />
        </IconButton>
        <IconButton size="small" aria-label="voice" disabled sx={{ width: 32, height: 32, borderRadius: 8, mr: 1 }}>
          <Mic size={22} />
        </IconButton>
        <IconButton
          size="small"
          aria-label="send"
          onClick={onSubmit}
          disabled={loading}
          sx={{
            width: '48px',
            height: '48px',
            borderRadius: '50%',
            bgcolor: '#000',
            color: '#fff',
            transition: 'transform 120ms ease, box-shadow 120ms ease, background-color 120ms ease',
            boxShadow: '0 2px 4px rgba(0,0,0,0.2)',
            '&:hover': { bgcolor: '#111', boxShadow: '0 6px 12px rgba(0,0,0,0.3)', transform: 'translateY(-1px)' },
            '&:active': { transform: 'translateY(0)' },
          }}
        >
          <Square size={20} fill="currentColor" stroke="none" />
        </IconButton>
      </Box>
    </Box>
  );
}

